export default __webpack_public_path__ + "static/media/riskometerH.293da8e4.png";